import type { GridCell, MultiplierPoolEntry } from '@core/types/cascade-slot.types';
import { RandomChoose } from './SymbolGenerator';

export function resolveMultiplier(pool: MultiplierPoolEntry[]): number {
  const weights = pool.map(e => e.weight);
  const index = RandomChoose(weights);
  return pool[index].value;
}

export function calculateBonusWin(tumbleWin: number, totalMultiplier: number): number {
  if (totalMultiplier <= 0 || tumbleWin <= 0) return 0;
  return tumbleWin * (totalMultiplier - 1);
}

export function collectMultipliers(grid: GridCell[][]): { count: number; totalMultiplier: number } {
  let count = 0;
  let totalMultiplier = 0;

  for (const row of grid) {
    for (const cell of row) {
      if (cell.symbolId === 'BN' && cell.multiplierValue > 0) {
        count++;
        totalMultiplier += cell.multiplierValue;
      }
    }
  }

  return { count, totalMultiplier };
}
